import { apiGet, apiPost, apiPut, apiDelete } from './api';
import API_CONFIG from '../config/api';

const { ENDPOINTS } = API_CONFIG;

export const EntrenadoresService = {
  async listarAdmin(page = 1, limit = 10, search = '') {
    try {
      let url = `${ENDPOINTS.ENTRENADORES.LISTAR}?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }

      const response = await apiGet(url);
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al listar relaciones');
      }

      return {
        items: data.items || [],
        pagination: data.pagination || {
          page: 1,
          limit: 10,
          total: data.items?.length || 0,
          total_pages: 1,
          has_next: false,
          has_prev: false
        }
      };
    } catch (error) {
      console.error('Error en listarAdmin entrenadores:', error);
      throw error;
    }
  },

  async crear(payload) {
    try {
      const response = await apiPost(ENDPOINTS.ENTRENADORES.CREAR, payload);
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al crear relación');
      }

      return data;
    } catch (error) {
      console.error('Error en crear relación entrenador-atleta:', error);
      throw error;
    }
  },

  async obtener(id) {
    try {
      const response = await apiGet(ENDPOINTS.ENTRENADORES.OBTENER(id));
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al obtener relación');
      }

      return data.item || data;
    } catch (error) {
      console.error('Error en obtener relación:', error);
      throw error;
    }
  },

  async editar(id, payload) {
    try {
      const response = await apiPut(ENDPOINTS.ENTRENADORES.EDITAR(id), payload);
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al editar relación');
      }

      return data;
    } catch (error) {
      console.error('Error en editar relación:', error);
      throw error;
    }
  },

  async eliminar(id) {
    try {
      const response = await apiDelete(ENDPOINTS.ENTRENADORES.ELIMINAR(id));
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al eliminar relación');
      }

      return data;
    } catch (error) {
      console.error('Error en eliminar relación:', error);
      throw error;
    }
  }
};
